import React, { useEffect } from "react"
import { graphql } from "gatsby"
import Layout from "../components/Layout"
import MapTo from "../utils/mapto"
import { documentToPlainTextString } from "@contentful/rich-text-plain-text-renderer"

const ContentfulPage = ({ data }) => {
  const { contentfulPageHcp } = data
  
  // Add effect to set document title and meta description
  useEffect(() => {
    // Set page title if available
    if (contentfulPageHcp?.pageTitle) {
      document.title = contentfulPageHcp.pageTitle;
    }
    
    // Set meta description if available
    if (contentfulPageHcp?.pageDescription?.raw) {
      // Convert Rich Text to plain text
      const plainTextDescription = documentToPlainTextString(
        JSON.parse(contentfulPageHcp.pageDescription.raw)
      );
      
      // Find existing description meta tag or create a new one
      let metaDescription = document.querySelector('meta[name="description"]');
      
      if (metaDescription) {
        // Update existing meta description
        metaDescription.setAttribute('content', plainTextDescription);
      } else {
        // Create new meta description if it doesn't exist
        metaDescription = document.createElement('meta');
        metaDescription.setAttribute('name', 'description');
        metaDescription.setAttribute('content', plainTextDescription);
        document.head.appendChild(metaDescription);
      }
    }
    
    // Clean up function (optional)
    return () => {
      // Cleanup if needed when component unmounts
    };
  }, [contentfulPageHcp]); // Only re-run when contentfulPageHcp changes
  
  return (
    <Layout backgroundColor={contentfulPageHcp?.backgroundColor} isi={{ isi: contentfulPageHcp?.isi, importantSafetyInformation: contentfulPageHcp?.importantSafetyInformation, indication: contentfulPageHcp?.indication }} references={contentfulPageHcp?.references} isEfficacyPage={true}>
      {contentfulPageHcp?.content?.map(item => <MapTo key={item.id} items={item}></MapTo>)}
	</Layout>
  )
}


export const query = graphql`
  query($id: String!) {
    contentfulPageHcp(id: { eq: $id }) {
      id
      entryTitle
      pageTitle
      pageDescription{
		__typename
        raw
      }
      slug
      backgroundColor
      header
        content {
            ...ContentfulPageContentItemFragment
        }
        isi{
            ...ContentfulRichTextFragment
        }
        references{
            ...ContentfulRichTextFragment
        }
        importantSafetyInformation{
          ...ContentfulRichTextFragment
        }
        indication{
          ...ContentfulRichTextFragment
        }
        header
    }
  }
`

export default ContentfulPage 
